import { useState, useCallback } from 'react';
import { apiService } from '../services/ApiService';
import { Midia } from '../types/Property';

export const useMedia = () => {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const uploadFiles = useCallback(async (imovelId: string, files: File[]) => {
    setUploading(true);
    setError(null);

    try {
      const response = await apiService.uploadMidias(imovelId, files);

      if (response.success && response.data) {
        return {
          success: true,
          data: response.data,
          message: response.message,
        };
      } else {
        setError(response.message || 'Erro no upload');
        return {
          success: false,
          message: response.message || 'Erro no upload',
        };
      }
    } catch (err: any) {
      setError(err.message || 'Erro no upload');
      return {
        success: false,
        message: err.message || 'Erro no upload',
      };
    } finally {
      setUploading(false);
    }
  }, []);

  const updateMedia = useCallback(async (id: string, data: {
    titulo?: string;
    descricao?: string;
    ordem?: number;
  }) => {
    try {
      const response = await apiService.updateMidia(id, data);

      if (response.success) {
        return {
          success: true,
          message: response.message,
        };
      } else {
        return {
          success: false,
          message: response.message || 'Erro ao atualizar mídia',
        };
      }
    } catch (err: any) {
      return {
        success: false,
        message: err.message || 'Erro ao atualizar mídia',
      };
    }
  }, []);

  const deleteMedia = useCallback(async (id: string) => {
    try {
      const response = await apiService.deleteMidia(id);

      if (response.success) {
        return {
          success: true,
          message: response.message,
        };
      } else {
        return {
          success: false,
          message: response.message || 'Erro ao deletar mídia',
        };
      }
    } catch (err: any) {
      return {
        success: false,
        message: err.message || 'Erro ao deletar mídia',
      };
    }
  }, []);

  const reorderMedia = useCallback(async (imovelId: string, midias: Array<{id: string, ordem: number}>) => {
    try {
      // Extrair apenas os IDs das mídias para enviar para a API
      const midiaIds = midias.map(midia => midia.id);
      const response = await apiService.reorderMidias(imovelId, midiaIds);

      if (response.success) {
        return {
          success: true,
          message: response.message,
        };
      } else {
        return {
          success: false,
          message: response.message || 'Erro ao reordenar mídias',
        };
      }
    } catch (err: any) {
      return {
        success: false,
        message: err.message || 'Erro ao reordenar mídias',
      };
    }
  }, []);

  return {
    uploading,
    error,
    uploadFiles,
    updateMedia,
    deleteMedia,
    reorderMedia,
  };
};

export const usePropertyMedia = (imovelId: string | null) => {
  const [midias, setMidias] = useState<Midia[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchMedia = useCallback(async () => {
    if (!imovelId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await apiService.getMidias(imovelId);

      if (response.success && response.data) {
        setMidias(response.data);
      } else {
        setError(response.message || 'Erro ao buscar mídias');
      }
    } catch (err: any) {
      setError(err.message || 'Erro ao buscar mídias');
    } finally {
      setLoading(false);
    }
  }, [imovelId]);

  return {
    midias,
    loading,
    error,
    fetchMedia,
  };
};
